
import { Component, Vue } from 'vue-property-decorator';

import axios from 'axios';

@Component
export default class Navbar extends Vue {
  private companyName: string | null = null;

  private async created(): Promise<void> {
    this.setTraceInsightSessionCookie();
    this.getCompanyName();
  }

  // This cookie is used to authenticate requests to the TracePhishing module
  private async setTraceInsightSessionCookie(): Promise<void> {
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    document.cookie = 'traceinsight_session=' + accessToken + '; SameSite=Strict; Secure';
  }

  private get supportAccessIsEnabled(): boolean {
    const appMetadata = (this as any).$auth0.user[process.env.VUE_APP_AUTH0_CUSTOM_CLAIM_NAMESPACE + '/app_metadata'];
    const supportAccessCompanyId = appMetadata['support_access_company_id'];
    return supportAccessCompanyId !== undefined && supportAccessCompanyId !== null;
  }

  private async getCompanyName(): Promise<void> {
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/companies/name`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      this.companyName = response.data;
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Getting Company Name',
        okVariant: 'danger',
        centered: true,
      });
    });
  }

  private disableSupportAccess(): void {
    (this as any).$auth0.loginWithRedirect({
      authorizationParams: {
        disableSupportAccess: true,
      },
    });
  }

  private handleLogout(): void {
    (this as any).$auth0.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }
}
